import { Icons } from '@components/common';

import { portalTasksStatuses } from '@constants/common';

export const getTaskStatusIcon = (status: string) => {
	switch (true) {
		case status === portalTasksStatuses.inProgress:
			return Icons.taskInProgress();

		case status === portalTasksStatuses.done:
			return Icons.taskDone();

		case status === portalTasksStatuses.toDo:
			return Icons.taskToDo();

		default:
			return;
	}
};
